export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "betmen-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "betmen-themeWrap" */'./ThemeImporter'),
  },
};
